import { REMOVE_KEYS } from "../../constants/constatnt-variable";

export const removeKeys = (obj) => {
    return _.omit(obj, REMOVE_KEYS);
};